// NATIVE
import { useEffect, useState } from 'react';

// INSTALLED
import { useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Checkbox, Divider, FormControlLabel, Grid, Typography } from '@mui/material';

// CUSTOM
import { uploadPdfStore } from 'store/uploaders';
import { UploadButtonField } from 'components/formFields/uploadButtonField';
import { LinearProgressWithLabel } from 'components/LinearProgressWithLabel';
import { PreviewPdfButton } from 'components/PreviewPdfButton';

export const EditPruebasIngreso = (props: any) => {
  const dispatch = useDispatch();

  // VISITA DOMICILIARIA
  const [vidomsi, setViDomSi] = useState(false);
  const [vidomno, setViDomNo] = useState(true);

  // PRUEBA PSICOTECNICA
  const [psicotecsi, setPsicotecSi] = useState(false);
  const [psicotecno, setPsicotecNo] = useState(true);

  // EXAMENES MANIULACION ALIMENTOS
  const [manipualsi, setManipualSi] = useState(false);
  const [manipualno, setManipualNo] = useState(true);

  // EXAMEN ALTURAS
  const [alturasi, setAlturaSi] = useState(false);
  const [alturano, setAlturaNo] = useState(true);

  // EXAMEN MEDICO
  const [examenmedsi, setExamenMedSi] = useState(false);
  const [examenmedno, setExamenMedNo] = useState(true);

  // CONTRATO
  const [contratosi, setContratoSi] = useState(false);
  const [contratono, setContratoNo] = useState(true);

  // CERTIFICADO ESTUDIO
  const [certificadoestudiosi, setCertificadoEstudioSi] = useState(false);
  const [certificadoestudiono, setCertificadoEstudioNo] = useState(true);

  // CERTIFICADO ESTUDIO
  const [certificadolaboralsi, setCertificadoLaboralSi] = useState(false);
  const [certificadolaboralno, setCertificadoLaboralNo] = useState(true);

  // VERIFICACION ADDRESS
  const [verificacionaddresi, setVerificacionAddressSi] = useState(false);
  const [verificacionaddreno, setVerificacionAddressNo] = useState(true);

  // ANTECEDENTES
  const [antecedentessi, setAntecedentesSi] = useState(false);
  const [antecedentesno, setAntecedentesNo] = useState(true);

  // ENTREVISTA
  const [entrevistasi, setEntrevistaSi] = useState(false);
  const [entrevistano, setEntrevistaNo] = useState(true);

  // ENTREVISTA SOCIODEMOGRAFICA
  const [sociodemograficasi, setSocioDemograficaSi] = useState(false);
  const [sociodemograficano, setSocioDemograficaNo] = useState(true);

  // ENCUESTA DME
  const [encuestadmesi, setencuestaDmeSi] = useState(false);
  const [encuestadmeno, setencuestaDmeNo] = useState(true);

  // COMPROMISO SST
  const [compromisosstsi, setCompromisoSstSi] = useState(false);
  const [compromisosstno, setCompromisoSstNo] = useState(true);

  const [showvisdom, setShowVisDom] = useState(false);

  const { employee } = useSelector((state: any) => state.employee);

  // UPLOADERS

  // VISITA DOMICILIARIA
  const [percentage_upload_vi_dom, setPercentageUploadViDom] = useState(0);

  // PRUEBA PSICOTECNICA
  const [percentage_upload_psicotec, setPercentageUploadPsicotec] = useState(0);

  // MANEJO ALIMENTOS
  const [percentage_upload_manejo_alimentos, setPercentageUploadManejoAlimentos] = useState(0);

  // MANEJO ALIMENTOS
  const [percentage_upload_trabajo_alturas, setPercentageUploadTrabajoAlturas] = useState(0);

  // MANEJO ALIMENTOS
  const [percentage_upload_examen_medico, setPercentageUploadExamenMedico] = useState(0);

  // MANEJO ALIMENTOS
  const [percentage_upload_certificado_estudio, setPercentageUploadCertificadoEstudios] =
    useState(0);

  // CERTIFICADO LABORAL
  const [percentage_upload_certificado_laboral, setPercentageUploadCertificadoLaboral] =
    useState(0);

  // VERIFICACION ADRES
  const [percentage_upload_verificacion_adres, setPercentageUploadVerificacionAdres] = useState(0);

  // ANTECEDENTES
  const [percentage_upload_antecedentes, setPercentageUploadAntecedentes] = useState(0);

  // ENTREVISTA
  const [percentage_upload_entrevista, setPercentageUploadEntrevista] = useState(0);

  // ENTREVISTA SOCIODEMOGRAFICA
  const [percentage_upload_entrevista_sociodemografica, setPercentageUploadSociodemografica] =
    useState(0);

  // ENCUESTA DME
  const [percentage_upload_encuesta_dme, setPercentageUploadEncuestaDme] = useState(0);

  // COMPROMISO SST
  const [percentage_upload_compromiso_sst, setPercentageUploadCompromisoSst] = useState(0);

  const formikProps: any = useFormikContext();

  const {
    formField: {
      // DATOS CLIENTE
      e_vista_domiciliaria,
      e_fileVisitaDomiciliaria,
      e_prueba_psicotecnica,
      e_filePsicotecnica,
      e_manipulacion_alimentos,
      e_fileManipulacionAlimentos,
      e_trabajo_alturas,
      e_fileTrabajoAlturas,
      e_examen_medico,
      e_fileExamenMedico,
      e_contrato,
      e_certificado_estudios,
      e_fileCertificadoEstudios,
      e_certificado_laboral,
      e_fileCertificadoLaboral,
      e_verificacion_adres,
      e_fileVerificacionAdres,
      e_antecedentes,
      e_fileAntecedentes,
      e_entrevista,
      e_fileEntrevista,
      e_sociodemografica,
      e_fileSociodemografica,
      e_encuesta_dme,
      e_fileEncuestaDme,
      e_compromiso_sst,
      e_fileCompromisoSst,
    },
  } = props;

  useEffect(() => {
    if (employee && Object.keys(employee).length > 0) {
      setEmployeeData(employee);
    }
  }, [employee]);

  const setEmployeeData = (employee: any) => {
    if (formikProps.values.is_initialized_pruebas_ingreso) return;
    formikProps.setFieldValue('is_initialized_pruebas_ingreso', true);

    // *************************************
    // ******** VISITA DOMICILIARIA ********
    // *************************************
    if (employee.vista_domiciliaria !== undefined)
      formikProps.setFieldValue('e_vista_domiciliaria', employee.vista_domiciliaria);
    if (employee.fileVisitaDomiciliaria)
      formikProps.setFieldValue('e_fileVisitaDomiciliaria', employee.fileVisitaDomiciliaria);
    if (employee.visita_domiciliaria_name_saved)
      formikProps.setFieldValue(
        'e_visita_domiciliaria_name_saved',
        employee.visita_domiciliaria_name_saved
      );

    if (employee.vista_domiciliaria) {
      setViDomSi(true);
      setViDomNo(false);
    } else {
      setViDomSi(false);
      setViDomNo(true);
    }

    // *************************************
    // ******** PRUEBA PSICOTECNICA ********
    // *************************************
    if (employee.prueba_psicotecnica !== undefined)
      formikProps.setFieldValue('e_prueba_psicotecnica', employee.prueba_psicotecnica);
    if (employee.filePsicotecnica)
      formikProps.setFieldValue('e_filePsicotecnica', employee.filePsicotecnica);
    if (employee.psicotecnica_name_saved)
      formikProps.setFieldValue('e_psicotecnica_name_saved', employee.psicotecnica_name_saved);

    if (employee.prueba_psicotecnica) {
      setPsicotecSi(true);
      setPsicotecNo(false);
    } else {
      setPsicotecSi(false);
      setPsicotecNo(true);
    }

    // *************************************
    // ***** MANIPULACION ALIMENTOS ********
    // *************************************
    if (employee.manipulacion_alimentos !== undefined)
      formikProps.setFieldValue('e_manipulacion_alimentos', employee.manipulacion_alimentos);
    if (employee.fileManipulacionAlimentos)
      formikProps.setFieldValue('e_fileManipulacionAlimentos', employee.fileManipulacionAlimentos);
    if (employee.manipulacion_alimentos_name_saved)
      formikProps.setFieldValue(
        'e_manipulacion_alimentos_name_saved',
        employee.manipulacion_alimentos_name_saved
      );

    if (employee.manipulacion_alimentos) {
      setManipualSi(true);
      setManipualNo(false);
    } else {
      setManipualSi(false);
      setManipualNo(true);
    }

    // *************************************
    // ******** TRABAJO EN ALTURAS *********
    // *************************************
    if (employee.trabajo_alturas !== undefined)
      formikProps.setFieldValue('e_trabajo_alturas', employee.trabajo_alturas);
    if (employee.fileTrabajoAlturas)
      formikProps.setFieldValue('e_fileTrabajoAlturas', employee.fileTrabajoAlturas);
    if (employee.trabajo_altura_name_saved)
      formikProps.setFieldValue('e_trabajo_altura_name_saved', employee.trabajo_altura_name_saved);

    if (employee.trabajo_alturas) {
      setAlturaSi(true);
      setAlturaNo(false);
    } else {
      setAlturaSi(false);
      setAlturaNo(true);
    }

    // *************************************
    // *********** EXAMEN MEDICO ***********
    // *************************************
    if (employee.examen_medico !== undefined)
      formikProps.setFieldValue('e_examen_medico', employee.examen_medico);
    if (employee.fileExamenMedico)
      formikProps.setFieldValue('e_fileExamenMedico', employee.fileExamenMedico);
    if (employee.examen_medico_name_saved)
      formikProps.setFieldValue('e_examen_medico_name_saved', employee.examen_medico_name_saved);

    if (employee.examen_medico) {
      setExamenMedSi(true);
      setExamenMedNo(false);
    } else {
      setExamenMedSi(false);
      setExamenMedNo(true);
    }

    // *************************************
    // *************** CONTRATO ************
    // *************************************
    if (employee.contrato !== undefined) formikProps.setFieldValue('e_contrato', employee.contrato);

    if (employee.contrato) {
      setContratoSi(true);
      setContratoNo(false);
    } else {
      setContratoSi(false);
      setContratoNo(true);
    }

    // *************************************
    // ****** CERTIFICADO ESTUDIOS *********
    // *************************************
    if (employee.certificado_estudios !== undefined)
      formikProps.setFieldValue('e_certificado_estudios', employee.certificado_estudios);
    if (employee.fileCertificadoEstudios)
      formikProps.setFieldValue('e_fileCertificadoEstudios', employee.fileCertificadoEstudios);
    if (employee.certificado_estudios_name_saved)
      formikProps.setFieldValue(
        'e_certificado_estudios_name_saved',
        employee.certificado_estudios_name_saved
      );

    if (employee.certificado_estudios) {
      setCertificadoEstudioSi(true);
      setCertificadoEstudioNo(false);
    } else {
      setCertificadoEstudioSi(false);
      setCertificadoEstudioNo(true);
    }

    // *************************************
    // ****** CERTIFICADO LABORAL **********
    // *************************************
    if (employee.certificado_laboral !== undefined)
      formikProps.setFieldValue('e_certificado_laboral', employee.certificado_laboral);
    if (employee.fileCertificadoLaboral)
      formikProps.setFieldValue('e_fileCertificadoLaboral', employee.fileCertificadoLaboral);
    if (employee.certificado_laboral_name_saved)
      formikProps.setFieldValue(
        'e_certificado_laboral_name_saved',
        employee.certificado_laboral_name_saved
      );

    if (employee.certificado_laboral) {
      setCertificadoLaboralSi(true);
      setCertificadoLaboralNo(false);
    } else {
      setCertificadoLaboralSi(false);
      setCertificadoLaboralNo(true);
    }

    // *************************************
    // ******** VERIFICACION ADRES *********
    // *************************************
    if (employee.verificacion_adres !== undefined)
      formikProps.setFieldValue('e_verificacion_adres', employee.verificacion_adres);
    if (employee.fileVerificacionAdres)
      formikProps.setFieldValue('e_fileVerificacionAdres', employee.fileVerificacionAdres);
    if (employee.verificacion_adres_name_saved)
      formikProps.setFieldValue(
        'e_verificacion_adres_name_saved',
        employee.verificacion_adres_name_saved
      );

    if (employee.verificacion_adres) {
      setVerificacionAddressSi(true);
      setVerificacionAddressNo(false);
    } else {
      setVerificacionAddressSi(false);
      setVerificacionAddressNo(true);
    }

    // *************************************
    // ************ ANTECEDENTES ***********
    // *************************************
    if (employee.antecedentes !== undefined)
      formikProps.setFieldValue('e_antecedentes', employee.antecedentes);
    if (employee.fileAntecedentes)
      formikProps.setFieldValue('e_fileAntecedentes', employee.fileAntecedentes);
    if (employee.antecedentes_name_saved)
      formikProps.setFieldValue('e_antecedentes_name_saved', employee.antecedentes_name_saved);

    if (employee.antecedentes) {
      setAntecedentesSi(true);
      setAntecedentesNo(false);
    } else {
      setAntecedentesSi(false);
      setAntecedentesNo(true);
    }

    // *************************************
    // ************* ENTREVISTA ************
    // *************************************
    if (employee.entrevista !== undefined)
      formikProps.setFieldValue('e_entrevista', employee.entrevista);
    if (employee.fileEntrevista)
      formikProps.setFieldValue('e_fileEntrevista', employee.fileEntrevista);
    if (employee.entrevista_name_saved)
      formikProps.setFieldValue('e_entrevista_name_saved', employee.entrevista_name_saved);

    if (employee.entrevista) {
      setEntrevistaSi(true);
      setEntrevistaNo(false);
    } else {
      setEntrevistaSi(false);
      setEntrevistaNo(true);
    }

    // *************************************
    // ******* SOCIODEMOGRAFICA ************
    // *************************************
    if (employee.sociodemografica !== undefined)
      formikProps.setFieldValue('e_sociodemografica', employee.sociodemografica);
    if (employee.fileSociodemografica)
      formikProps.setFieldValue('e_fileSociodemografica', employee.fileSociodemografica);
    if (employee.sociodemografica_name_saved)
      formikProps.setFieldValue(
        'e_sociodemografica_name_saved',
        employee.sociodemografica_name_saved
      );

    if (employee.sociodemografica) {
      setSocioDemograficaSi(true);
      setSocioDemograficaNo(false);
    } else {
      setSocioDemograficaSi(false);
      setSocioDemograficaNo(true);
    }

    // *************************************
    // ********** ENCUESTA DME *************
    // *************************************
    if (employee.encuesta_dme !== undefined)
      formikProps.setFieldValue('e_encuesta_dme', employee.encuesta_dme);
    if (employee.fileEncuestaDme)
      formikProps.setFieldValue('e_fileEncuestaDme', employee.fileEncuestaDme);
    if (employee.encuesta_dme_name_saved)
      formikProps.setFieldValue('e_encuesta_dme_name_saved', employee.encuesta_dme_name_saved);

    if (employee.encuesta_dme) {
      setencuestaDmeSi(true);
      setencuestaDmeNo(false);
    } else {
      setencuestaDmeSi(false);
      setencuestaDmeNo(true);
    }

    // *************************************
    // ******** COMPROMISO SST *************
    // *************************************
    if (employee.compromiso_sst !== undefined)
      formikProps.setFieldValue('e_compromiso_sst', employee.compromiso_sst);
    if (employee.fileCompromisoSst)
      formikProps.setFieldValue('e_fileCompromisoSst', employee.fileCompromisoSst);
    if (employee.compromiso_sst_name_saved)
      formikProps.setFieldValue('e_compromiso_sst_name_saved', employee.compromiso_sst_name_saved);

    if (employee.compromiso_sst) {
      setCompromisoSstSi(true);
      setCompromisoSstNo(false);
    } else {
      setCompromisoSstSi(false);
      setCompromisoSstNo(true);
    }
  };

  // const setEmployeeData = (employee:any) => {

  //       console.log('EditPruebasIngreso ', employee)

  //         // Por cada campo, setea el valor en formikProps usando el valor de employee
  //         // La llave es el nombre del campo sin el prefijo 'e_'
  //         if (employee.vista_domiciliaria !== undefined) formikProps.setFieldValue('e_vista_domiciliaria', employee.vista_domiciliaria);
  //         if (employee.fileVisitaDomiciliaria) formikProps.setFieldValue('e_fileVisitaDomiciliaria', employee.fileVisitaDomiciliaria);
  //         if (employee.visita_domiciliaria_name_saved) formikProps.setFieldValue('e_visita_domiciliaria_name_saved', employee.visita_domiciliaria_name_saved);

  //         if (employee.prueba_psicotecnica !== undefined) formikProps.setFieldValue('e_prueba_psicotecnica', employee.prueba_psicotecnica);
  //         if (employee.filePsicotecnica) formikProps.setFieldValue('e_filePsicotecnica', employee.filePsicotecnica);
  //         if (employee.psicotecnica_name_saved) formikProps.setFieldValue('e_psicotecnica_name_saved', employee.psicotecnica_name_saved);

  //         if (employee.manipulacion_alimentos !== undefined) formikProps.setFieldValue('e_manipulacion_alimentos', employee.manipulacion_alimentos);
  //         if (employee.fileManipulacionAlimentos) formikProps.setFieldValue('e_fileManipulacionAlimentos', employee.fileManipulacionAlimentos);
  //         if (employee.manipulacion_alimentos_name_saved) formikProps.setFieldValue('e_manipulacion_alimentos_name_saved', employee.manipulacion_alimentos_name_saved);

  //         if (employee.trabajo_alturas !== undefined) formikProps.setFieldValue('e_trabajo_alturas', employee.trabajo_alturas);
  //         if (employee.fileTrabajoAlturas) formikProps.setFieldValue('e_fileTrabajoAlturas', employee.fileTrabajoAlturas);
  //         if (employee.trabajo_altura_name_saved) formikProps.setFieldValue('e_trabajo_altura_name_saved', employee.trabajo_altura_name_saved);

  //         if (employee.examen_medico !== undefined) formikProps.setFieldValue('e_examen_medico', employee.examen_medico);
  //         if (employee.fileExamenMedico) formikProps.setFieldValue('e_fileExamenMedico', employee.fileExamenMedico);
  //         if (employee.examen_medico_name_saved) formikProps.setFieldValue('e_examen_medico_name_saved', employee.examen_medico_name_saved);

  //         if (employee.contrato !== undefined) formikProps.setFieldValue('e_contrato', employee.contrato);

  //         if (employee.certificado_estudios !== undefined) formikProps.setFieldValue('e_certificado_estudios', employee.certificado_estudios);
  //         if (employee.fileCertificadoEstudios) formikProps.setFieldValue('e_fileCertificadoEstudios', employee.fileCertificadoEstudios);
  //         if (employee.certificado_estudios_name_saved) formikProps.setFieldValue('e_certificado_estudios_name_saved', employee.certificado_estudios_name_saved);

  //         if (employee.certificado_laboral !== undefined) formikProps.setFieldValue('e_certificado_laboral', employee.certificado_laboral);
  //         if (employee.fileCertificadoLaboral) formikProps.setFieldValue('e_fileCertificadoLaboral', employee.fileCertificadoLaboral);
  //         if (employee.certificado_laboral_name_saved) formikProps.setFieldValue('e_certificado_laboral_name_saved', employee.certificado_laboral_name_saved);

  //         if (employee.verificacion_adres !== undefined) formikProps.setFieldValue('e_verificacion_adres', employee.verificacion_adres);
  //         if (employee.fileVerificacionAdres) formikProps.setFieldValue('e_fileVerificacionAdres', employee.fileVerificacionAdres);
  //         if (employee.verificacion_adres_name_saved) formikProps.setFieldValue('e_verificacion_adres_name_saved', employee.verificacion_adres_name_saved);

  //         if (employee.antecedentes !== undefined) formikProps.setFieldValue('e_antecedentes', employee.antecedentes);
  //         if (employee.fileAntecedentes) formikProps.setFieldValue('e_fileAntecedentes', employee.fileAntecedentes);
  //         if (employee.antecedentes_name_saved) formikProps.setFieldValue('e_antecedentes_name_saved', employee.antecedentes_name_saved);

  //         if (employee.entrevista !== undefined) formikProps.setFieldValue('e_entrevista', employee.entrevista);
  //         if (employee.fileEntrevista) formikProps.setFieldValue('e_fileEntrevista', employee.fileEntrevista);
  //         if (employee.entrevista_name_saved) formikProps.setFieldValue('e_entrevista_name_saved', employee.entrevista_name_saved);

  //         if (employee.sociodemografica !== undefined) formikProps.setFieldValue('e_sociodemografica', employee.sociodemografica);
  //         if (employee.fileSociodemografica) formikProps.setFieldValue('e_fileSociodemografica', employee.fileSociodemografica);
  //         if (employee.sociodemografica_name_saved) formikProps.setFieldValue('e_sociodemografica_name_saved', employee.sociodemografica_name_saved);

  //         // *************************************
  //         // ********** ENCUESTA DME ************
  //         // *************************************
  //         if (employee.encuesta_dme !== undefined) formikProps.setFieldValue('e_encuesta_dme', employee.encuesta_dme);
  //         if (employee.fileEncuestaDme) formikProps.setFieldValue('e_fileEncuestaDme', employee.fileEncuestaDme);
  //         if (employee.encuesta_dme_name_saved) formikProps.setFieldValue('e_encuesta_dme_name_saved', employee.encuesta_dme_name_saved);

  //         if (employee.encuesta_dme) {
  //            setencuestaDmeSi(true);
  //            setencuestaDmeNo(false);
  //         }else{
  //             setencuestaDmeSi(false);
  //             setencuestaDmeNo(true);
  //         }
  //         // *************************************
  //         // *********FIN ENCUESTA DME ***********
  //         // *************************************

  //         // *************************************
  //         // *********** COMPROMISO SST **********
  //         // *************************************
  //         if (employee.compromiso_sst !== undefined) formikProps.setFieldValue('e_compromiso_sst', employee.compromiso_sst);
  //         if (employee.fileCompromisoSst) formikProps.setFieldValue('e_fileCompromisoSst', employee.fileCompromisoSst);
  //         if (employee.compromiso_sst_name_saved) formikProps.setFieldValue('e_compromiso_sst_name_saved', employee.compromiso_sst_name_saved);

  //          if (employee.encuesta_dme) {
  //            setCompromisoSstSi(true);
  //            setCompromisoSstNo(false);
  //         }else{
  //             setCompromisoSstSi(false);
  //             setCompromisoSstNo(true);
  //         }
  //         // *************************************
  //         // ********* FIN COMPROMISO SST ********
  //         // *************************************

  // }

  // VISITA DOMICILIARIA
  const visDomSi = () => {
    formikProps.setFieldValue('e_vista_domiciliaria', true);

    setViDomSi(true);
    setViDomNo(false);
  };
  const visDomNo = () => {
    formikProps.setFieldValue('e_vista_domiciliaria', false);
    setViDomSi(false);
    setViDomNo(true);
  };

  const uploadVisDom = async ({ target }: any) => {
    formikProps.setFieldValue('e_fileVisitaDomiciliaria', target.files[0]);
    const { ok, data } = await dispatch(
      uploadPdfStore('laboral-empleado', target.files[0], setPercentageUploadViDom)
    );

    if (ok) {
      formikProps.setFieldValue('e_visita_domiciliaria_name_saved', data.pdfName);
    }
  };
  // END VISITA DOMICILIARIA

  // PSICOTECNICA
  const psicotecSi = () => {
    formikProps.setFieldValue('e_prueba_psicotecnica', true);

    setPsicotecSi(true);
    setPsicotecNo(false);
  };
  const psicotecNo = () => {
    formikProps.setFieldValue('e_prueba_psicotecnica', false);
    setPsicotecSi(false);
    setPsicotecNo(true);
  };
  const uploadPsiq = async ({ target }: any) => {
    formikProps.setFieldValue('e_filePsicotecnica', target.files[0]);
    const { ok, data } = await dispatch(
      uploadPdfStore('laboral-empleado', target.files[0], setPercentageUploadPsicotec)
    );

    if (ok) {
      formikProps.setFieldValue('e_psicotecnica_name_saved', data.pdfName);
    }
  };
  // END PSICOTECNICA

  // MANIPULACION ALIMENTOS
  const examenManAlimentosSi = () => {
    formikProps.setFieldValue('e_manipulacion_alimentos', true);

    setManipualSi(true);
    setManipualNo(false);
  };
  const examenManAlimentosNo = () => {
    formikProps.setFieldValue('e_manipulacion_alimentos', false);
    setManipualSi(false);
    setManipualNo(true);
  };
  const uploadManipulacionAlimentos = async ({ target }: any) => {
    formikProps.setFieldValue('e_fileManipulacionAlimentos', target.files[0]);
    const { ok, data } = await dispatch(
      uploadPdfStore('laboral-empleado', target.files[0], setPercentageUploadManejoAlimentos)
    );

    if (ok) {
      formikProps.setFieldValue('e_manipulacion_alimentos_name_saved', data.pdfName);
    }
  };
  // END MANIPULACION DE ALIMENTOS

  // TRABAJO EN ALTURAS
  const trabajoAlturasSi = () => {
    formikProps.setFieldValue('e_trabajo_alturas', true);

    setAlturaSi(true);
    setAlturaNo(false);
  };
  const trabajoAlturasNo = () => {
    formikProps.setFieldValue('e_trabajo_alturas', false);
    setAlturaSi(false);
    setAlturaNo(true);
  };
  const uploadTrabajoAlturas = async ({ target }: any) => {
    formikProps.setFieldValue('e_fileTrabajoAlturas', target.files[0]);
    const { ok, data } = await dispatch(
      uploadPdfStore('laboral-empleado', target.files[0], setPercentageUploadTrabajoAlturas)
    );

    if (ok) {
      formikProps.setFieldValue('e_trabajo_altura_name_saved', data.pdfName);
    }
  };
  // END TRABAJO EN ALTURAS

  // EXAMEN MEDICO
  const examenMedicoSi = () => {
    formikProps.setFieldValue('e_examen_medico', true);
    setExamenMedSi(true);
    setExamenMedNo(false);
  };
  const examenMedicoNo = () => {
    formikProps.setFieldValue('e_examen_medico', false);
    setExamenMedSi(false);
    setExamenMedNo(true);
  };
  const uploadExamenMedico = async ({ target }: any) => {
    formikProps.setFieldValue('e_fileExamenMedico', target.files[0]);
    const { ok, data } = await dispatch(
      uploadPdfStore('laboral-empleado', target.files[0], setPercentageUploadExamenMedico)
    );

    if (ok) {
      formikProps.setFieldValue('e_examen_medico_name_saved', data.pdfName);
    }
  };
  // END EXAMEN MEDICO

  // CONTRATO
  const contratoSi = () => {
    formikProps.setFieldValue('e_contrato', true);
    setContratoSi(true);
    setContratoNo(false);
  };
  const contratoNo = () => {
    formikProps.setFieldValue('e_contrato', false);
    setContratoSi(false);
    setContratoNo(true);
  };
  // END CONTRATO

  // CERTIFICADO ESTUDIO
  const certificadoEstudioSi = () => {
    formikProps.setFieldValue('e_certificado_estudios', true);
    setCertificadoEstudioSi(true);
    setCertificadoEstudioNo(false);
  };
  const certificadoEstudioNo = () => {
    formikProps.setFieldValue('e_certificado_estudios', false);
    setCertificadoEstudioSi(false);
    setCertificadoEstudioNo(true);
  };
  const uploadCertificadoEstudio = async ({ target }: any) => {
    formikProps.setFieldValue('e_fileCertificadoEstudios', target.files[0]);
    const { ok, data } = await dispatch(
      uploadPdfStore('laboral-empleado', target.files[0], setPercentageUploadCertificadoEstudios)
    );

    if (ok) {
      formikProps.setFieldValue('e_certificado_estudios_name_saved', data.pdfName);
    }
  };
  // END CERTIFICADO ESTUDIO

  // CERTIFICADO LABORAL
  const certificadoLaboralSi = () => {
    formikProps.setFieldValue('e_certificado_laboral', true);
    setCertificadoLaboralSi(true);
    setCertificadoLaboralNo(false);
  };
  const certificadoLaboralNo = () => {
    formikProps.setFieldValue('e_certificado_laboral', false);
    setCertificadoLaboralSi(false);
    setCertificadoLaboralNo(true);
  };
  const uploadCertificadoLaboral = async ({ target }: any) => {
    formikProps.setFieldValue('e_fileCertificadoLaboral', target.files[0]);
    const { ok, data } = await dispatch(
      uploadPdfStore('laboral-empleado', target.files[0], setPercentageUploadCertificadoLaboral)
    );

    if (ok) {
      formikProps.setFieldValue('e_certificado_laboral_name_saved', data.pdfName);
    }
  };
  // END CERTIFICADO LABORAL

  // VERIFICACION ADDRESS
  const verificacionAddresSi = () => {
    formikProps.setFieldValue('e_verificacion_adres', true);
    setVerificacionAddressSi(true);
    setVerificacionAddressNo(false);
  };
  const verificacionAddresNo = () => {
    formikProps.setFieldValue('e_verificacion_adres', false);
    setVerificacionAddressSi(false);
    setVerificacionAddressNo(true);
  };
  const uploadVerificacionAdres = async ({ target }: any) => {
    formikProps.setFieldValue('e_fileVerificacionAdres', target.files[0]);
    const { ok, data } = await dispatch(
      uploadPdfStore('laboral-empleado', target.files[0], setPercentageUploadVerificacionAdres)
    );

    if (ok) {
      formikProps.setFieldValue('e_verificacion_adres_name_saved', data.pdfName);
    }
  };
  // END VERIFICACION ADDRESS

  // ANTECEDENTES
  const antecedentesSi = () => {
    formikProps.setFieldValue('e_antecedentes', true);
    setAntecedentesSi(true);
    setAntecedentesNo(false);
  };
  const antecedentesNo = () => {
    formikProps.setFieldValue('e_antecedentes', false);
    setAntecedentesSi(false);
    setAntecedentesNo(true);
  };
  const uploadAntecedentes = async ({ target }: any) => {
    formikProps.setFieldValue('e_fileAntecedentes', target.files[0]);
    const { ok, data } = await dispatch(
      uploadPdfStore('laboral-empleado', target.files[0], setPercentageUploadAntecedentes)
    );

    if (ok) {
      formikProps.setFieldValue('e_antecedentes_name_saved', data.pdfName);
    }
  };
  // END ANTECEDENTES

  // ENTREVISTA
  const entrevistaSi = () => {
    formikProps.setFieldValue('e_entrevista', true);
    setEntrevistaSi(true);
    setEntrevistaNo(false);
  };
  const entrevistaNo = () => {
    formikProps.setFieldValue('e_entrevista', false);
    setEntrevistaSi(false);
    setEntrevistaNo(true);
  };
  const uploaEntrevista = async ({ target }: any) => {
    formikProps.setFieldValue('e_fileEntrevista', target.files[0]);
    const { ok, data } = await dispatch(
      uploadPdfStore('laboral-empleado', target.files[0], setPercentageUploadEntrevista)
    );

    if (ok) {
      formikProps.setFieldValue('e_entrevista_name_saved', data.pdfName);
    }
  };
  // END ENTREVISTA

  // ENTREVISTA SOCIODEMOGRAFICA
  const socioDemograficaSi = () => {
    formikProps.setFieldValue('e_sociodemografica', true);
    setSocioDemograficaSi(true);
    setSocioDemograficaNo(false);
  };
  const socioDemograficaNo = () => {
    formikProps.setFieldValue('e_sociodemografica', false);
    setSocioDemograficaSi(false);
    setSocioDemograficaNo(true);
  };
  const uploaEntrevistaSociodemografica = async ({ target }: any) => {
    formikProps.setFieldValue('e_fileSociodemografica', target.files[0]);
    const { ok, data } = await dispatch(
      uploadPdfStore('laboral-empleado', target.files[0], setPercentageUploadSociodemografica)
    );

    if (ok) {
      formikProps.setFieldValue('e_sociodemografica_name_saved', data.pdfName);
    }
  };
  // END ENTREVISTA SOCIODEMOGRAFICA

  // ENCUESTA DME
  const encuestaDmeSi = () => {
    formikProps.setFieldValue('e_encuesta_dme', true);
    setencuestaDmeSi(true);
    setencuestaDmeNo(false);
  };
  const encuestaDmeNo = () => {
    formikProps.setFieldValue('e_encuesta_dme', false);
    setencuestaDmeSi(false);
    setencuestaDmeNo(true);
  };
  const uploadEncuestaDme = async ({ target }: any) => {
    formikProps.setFieldValue('e_fileEncuestaDme', target.files[0]);
    const { ok, data } = await dispatch(
      uploadPdfStore('laboral-empleado', target.files[0], setPercentageUploadEncuestaDme)
    );

    if (ok) {
      formikProps.setFieldValue('e_encuesta_dme_name_saved', data.pdfName);
    }
  };
  // END ENCUESTA DME

  // COMPROMISO SST
  const compromisoSstSi = () => {
    formikProps.setFieldValue('e_compromiso_sst', true);
    setCompromisoSstSi(true);
    setCompromisoSstNo(false);
  };
  const compromisoSstNo = () => {
    formikProps.setFieldValue('e_compromiso_sst', false);
    setCompromisoSstSi(false);
    setCompromisoSstNo(true);
  };
  const uploadCompromisoSst = async ({ target }: any) => {
    formikProps.setFieldValue('e_fileCompromisoSst', target.files[0]);
    const { ok, data } = await dispatch(
      uploadPdfStore('laboral-empleado', target.files[0], setPercentageUploadCompromisoSst)
    );

    if (ok) {
      formikProps.setFieldValue('e_compromiso_sst_name_saved', data.pdfName);
    }
  };
  // END COMPROMISO SST

  // END PSICOTECNICA

  const exmIngreso = async ({ target }: any) => {
    formikProps.setFieldValue('e_filePsicotecnica', target.files[0]);
    const { ok, data } = await dispatch(
      uploadPdfStore('laboral-empleado', target.files[0], setPercentageUploadPsicotec)
    );

    if (ok) {
      formikProps.setFieldValue('e_visita_domiciliaria_name_saved', data.pdfName);
    }
  };
  // END PSICOTECNICA

  return (
    <div>
      <Grid container spacing={2}>
        <Grid size={{ xs: 3 }}>
          <Typography sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>
            ¿Visita domiciliaria?
          </Typography>

          <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => visDomSi()}
                      name={'vista_domiciliaria_si'}
                      checked={vidomsi}
                    />
                  }
                  label={'Si'}
                />
              </div>
            </Grid>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => visDomNo()}
                      name={'vista_domiciliaria_no'}
                      checked={vidomno}
                    />
                  }
                  label={'No'}
                />
              </div>
            </Grid>
          </Grid>

          {/* FILE VISITA DOMICILIARIA  */}
          {vidomsi && (
            <UploadButtonField
              accept={'application/pdf'}
              name={e_fileVisitaDomiciliaria.name}
              label={e_fileVisitaDomiciliaria.label}
              required={
                !(
                  formikProps.values.e_fileVisitaDomiciliaria ||
                  (formikProps.values.e_visita_domiciliaria_name_saved &&
                    !formikProps.values.e_visita_domiciliaria_name_saved.includes('dummy'))
                )
              }
              text={'Visita domiciliaria'}
              onChange={uploadVisDom}
              style={{ marginTop: 10, width: '100%' }}
            />
          )}

          {vidomsi &&
          (formikProps.values.e_fileVisitaDomiciliaria ||
            formikProps.values.e_visita_domiciliaria_name_saved) ? (
            <Card variant="elevation" sx={{ marginTop: 1.5, padding: 1 }}>
              <LinearProgressWithLabel
                style={{ flex: 1, flexWrap: 'wrap' }}
                percentage={
                  formikProps.values.e_visita_domiciliaria_name_saved
                    ? 100
                    : percentage_upload_vi_dom
                }
                label={formikProps.values.e_fileVisitaDomiciliaria?.name || 'Visita domiciliaria'}
                hasIcon={true}
              />
              {!String(formikProps.values.e_visita_domiciliaria_name_saved).includes('dummy') && (
                <PreviewPdfButton
                  fileName={formikProps.values.e_visita_domiciliaria_name_saved}
                  typeUrl="laboral-empleado"
                  onOpenPdf={props.onOpenPdf}
                />
              )}
            </Card>
          ) : (
            ''
          )}
          {/* END FILE VISITA DOMICILIARIA  */}
        </Grid>

        <Grid size={{ xs: 3 }}></Grid>

        <Grid size={{ xs: 3 }}>
          <Typography sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>
            ¿Prueba Psicotecnica?
          </Typography>

          <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => psicotecSi()}
                      name={'psicotecnica_si'}
                      checked={psicotecsi}
                    />
                  }
                  label={'Si'}
                />
              </div>
            </Grid>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => psicotecNo()}
                      name={'psicotecnica_no'}
                      checked={psicotecno}
                    />
                  }
                  label={'No'}
                />
              </div>
            </Grid>
          </Grid>

          {/* FILE PRUEBA PSICOTECNICA  */}
          {psicotecsi && (
            <UploadButtonField
              accept={'application/pdf'}
              name={e_filePsicotecnica.name}
              label={e_filePsicotecnica.label}
              required={
                !(
                  formikProps.values.e_filePsicotecnica ||
                  (formikProps.values.e_psicotecnica_name_saved &&
                    !formikProps.values.e_psicotecnica_name_saved.includes('dummy'))
                )
              }
              text={'Prueba psicotecnica'}
              onChange={uploadPsiq}
              style={{ marginTop: 10, width: '100%' }}
            />
          )}

          {psicotecsi &&
          (formikProps.values.e_filePsicotecnica ||
            formikProps.values.e_psicotecnica_name_saved) ? (
            <Card variant="elevation" sx={{ marginTop: 1.5, padding: 1 }}>
              <LinearProgressWithLabel
                percentage={
                  formikProps.values.e_psicotecnica_name_saved ? 100 : percentage_upload_psicotec
                }
                label={formikProps.values.e_filePsicotecnica?.name || 'Prueba psicotecnica'}
                hasIcon={true}
              />
              {!String(formikProps.values.e_psicotecnica_name_saved).includes('dummy') && (
                <PreviewPdfButton
                  fileName={formikProps.values.e_psicotecnica_name_saved}
                  typeUrl="laboral-empleado"
                  onOpenPdf={props.onOpenPdf}
                />
              )}
            </Card>
          ) : (
            ''
          )}
          {/* END FILE PRUEBA PSICOTECNICA  */}
        </Grid>

        <Grid size={{ xs: 3 }}></Grid>

        <Grid size={{ xs: 3 }}></Grid>
      </Grid>
      {/* END GRID  */}

      <Divider sx={{ marginTop: 5 }} />
      <Grid container spacing={2}>
        <Typography
          variant="h6"
          sx={{
            marginTop: 4,
            fontWeight: 'bold',
            background: '#eceaea',
            padding: 2,
            width: '100%',
          }}
        >
          Examenes habilidades tecnicas
        </Typography>
      </Grid>

      <Grid container spacing={2}>
        <Grid size={{ xs: 3 }}>
          <Typography sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>
            ¿Examen de manipulacion de alimentos?
          </Typography>

          <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => examenManAlimentosSi()}
                      name={'alturas_si'}
                      checked={manipualsi}
                    />
                  }
                  label={'Si'}
                />
              </div>
            </Grid>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => examenManAlimentosNo()}
                      name={'alturas_no'}
                      checked={manipualno}
                    />
                  }
                  label={'No'}
                />
              </div>
            </Grid>
          </Grid>

          {/* MANIPULACION ALIMENTOS  */}
          {manipualsi && (
            <UploadButtonField
              accept={'application/pdf'}
              name={e_fileManipulacionAlimentos.name}
              label={e_fileManipulacionAlimentos.label}
              required={
                !(
                  formikProps.values.e_fileManipulacionAlimentos ||
                  (formikProps.values.e_manipulacion_alimentos_name_saved &&
                    !formikProps.values.e_manipulacion_alimentos_name_saved.includes('dummy'))
                )
              }
              text={'Manipulacion alimentos'}
              onChange={uploadManipulacionAlimentos}
              style={{ marginTop: 10, width: '100%' }}
            />
          )}

          {manipualsi &&
          (formikProps.values.e_fileManipulacionAlimentos ||
            formikProps.values.e_manipulacion_alimentos_name_saved) ? (
            <Card variant="elevation" sx={{ marginTop: 1.5, padding: 1 }}>
              <LinearProgressWithLabel
                percentage={
                  formikProps.values.e_manipulacion_alimentos_name_saved
                    ? 100
                    : percentage_upload_manejo_alimentos
                }
                label={
                  formikProps.values.e_fileManipulacionAlimentos?.name || 'Manipulacion alimentos'
                }
                hasIcon={true}
              />
              {!String(formikProps.values.e_manipulacion_alimentos_name_saved).includes(
                'dummy'
              ) && (
                <PreviewPdfButton
                  fileName={formikProps.values.e_manipulacion_alimentos_name_saved}
                  typeUrl="laboral-empleado"
                  onOpenPdf={props.onOpenPdf}
                />
              )}
            </Card>
          ) : (
            ''
          )}
          {/* END MANIPULACION ALIMENTOS   */}
        </Grid>

        <Grid size={{ xs: 3 }}></Grid>

        <Grid size={{ xs: 3 }}>
          <Typography sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>
            ¿Examen para trabajo en alturas?
          </Typography>

          <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => trabajoAlturasSi()}
                      name={'trabajo_alturas_si'}
                      checked={alturasi}
                    />
                  }
                  label={'Si'}
                />
              </div>
            </Grid>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => trabajoAlturasNo()}
                      name={'trabajo_alturas_no'}
                      checked={alturano}
                    />
                  }
                  label={'No'}
                />
              </div>
            </Grid>
          </Grid>

          {/* FILE TRABAJO EN ALTURAS  */}
          {alturasi && (
            <UploadButtonField
              accept={'application/pdf'}
              name={e_fileTrabajoAlturas.name}
              label={e_fileTrabajoAlturas.label}
              required={
                !(
                  formikProps.values.e_fileTrabajoAlturas ||
                  (formikProps.values.e_trabajo_alturas_name_saved &&
                    !formikProps.values.e_trabajo_alturas_name_saved.includes('dummy'))
                )
              }
              text={'Trabajo en alturas'}
              onChange={uploadTrabajoAlturas}
              style={{ marginTop: 10, width: '100%' }}
            />
          )}

          {alturasi &&
          (formikProps.values.e_fileTrabajoAlturas ||
            formikProps.values.e_trabajo_altura_name_saved) ? (
            <Card variant="elevation" sx={{ marginTop: 1.5, padding: 1 }}>
              <LinearProgressWithLabel
                percentage={
                  formikProps.values.e_trabajo_altura_name_saved
                    ? 100
                    : percentage_upload_trabajo_alturas
                }
                label={formikProps.values.e_fileTrabajoAlturas?.name || 'Trabajo en alturas'}
                hasIcon={true}
              />
              {!String(formikProps.values.e_trabajo_altura_name_saved).includes('dummy') && (
                <PreviewPdfButton
                  fileName={formikProps.values.e_trabajo_altura_name_saved}
                  typeUrl="laboral-empleado"
                  onOpenPdf={props.onOpenPdf}
                />
              )}
            </Card>
          ) : (
            ''
          )}
          {/* END FILE TRABAJO EN ALTURAS  */}
        </Grid>
      </Grid>
      {/* END GRID  */}

      <Divider sx={{ marginTop: 4 }} />
      <Grid container spacing={2}>
        <Typography
          variant="h6"
          sx={{
            marginTop: 4,
            fontWeight: 'bold',
            background: '#eceaea',
            padding: 2,
            width: '100%',
          }}
        >
          Examenes Medicos
        </Typography>
      </Grid>

      <Grid container spacing={2}>
        <Grid size={{ xs: 3 }}>
          <Typography sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>
            Examen ingreso
          </Typography>

          <UploadButtonField
            accept={'application/pdf'}
            name={e_fileExamenMedico.name}
            label={e_fileExamenMedico.label}
            required={
              !(
                formikProps.values.e_fileExamenMedico ||
                (formikProps.values.e_examen_medico_name_saved &&
                  !formikProps.values.e_examen_medico_name_saved.includes('dummy'))
              )
            }
            text={'Examen medico'}
            onChange={uploadExamenMedico}
            style={{ marginTop: 10, width: '100%' }}
          />

          {/*FILE EXAMEN MEDICO  */}
          {(alturasi ||
            formikProps.values.e_fileExamenMedico ||
            formikProps.values.e_examen_medico_name_saved) &&
          (formikProps.values.e_fileExamenMedico ||
            formikProps.values.e_examen_medico_name_saved) ? (
            <Card variant="elevation" sx={{ marginTop: 1.5, padding: 1 }}>
              <LinearProgressWithLabel
                percentage={
                  formikProps.values.e_examen_medico_name_saved
                    ? 100
                    : percentage_upload_examen_medico
                }
                label={formikProps.values.e_fileExamenMedico?.name || 'Examen medico'}
                hasIcon={true}
              />
              {!String(formikProps.values.e_examen_medico_name_saved).includes('dummy') && (
                <PreviewPdfButton
                  fileName={formikProps.values.e_examen_medico_name_saved}
                  typeUrl="laboral-empleado"
                  onOpenPdf={props.onOpenPdf}
                />
              )}
            </Card>
          ) : (
            ''
          )}
          {/* END FILE EXAMEN MEDICO  */}
        </Grid>

        <Grid size={{ xs: 3 }}></Grid>

        <Grid size={{ xs: 3 }}>
          <Typography sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>Apto?</Typography>

          <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => examenMedicoSi()}
                      name={'ex_medico_si'}
                      checked={examenmedsi}
                    />
                  }
                  label={'Si'}
                />
              </div>
            </Grid>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => examenMedicoNo()}
                      name={'ex_medico_no'}
                      checked={examenmedno}
                    />
                  }
                  label={'No'}
                />
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {/* END GRID  */}

      <Divider sx={{ marginTop: 4 }} />
      <Grid container spacing={2}>
        <Typography
          variant="h6"
          sx={{
            marginTop: 4,
            fontWeight: 'bold',
            background: '#eceaea',
            padding: 2,
            width: '100%',
          }}
        >
          Documentacíon requerida para el ingreso
        </Typography>
      </Grid>

      <Grid container spacing={2} sx={{ marginTop: 2 }}>
        <Grid size={{ xs: 3 }}>
          <Typography sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>
            Contrato?
          </Typography>

          <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => contratoSi()}
                      name={'contrato_si'}
                      checked={contratosi}
                    />
                  }
                  label={'Si'}
                />
              </div>
            </Grid>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => contratoNo()}
                      name={'contrato_no'}
                      checked={contratono}
                    />
                  }
                  label={'No'}
                />
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid size={{ xs: 1 }}></Grid>

        <Grid size={{ xs: 3 }}>
          <Typography sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>
            ¿Certificado de estudio?
          </Typography>
          <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => certificadoEstudioSi()}
                      name={'certificado_estudio_si'}
                      checked={certificadoestudiosi}
                    />
                  }
                  label={'Si'}
                />
              </div>
            </Grid>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => certificadoEstudioNo()}
                      name={'certificado_estudio_no'}
                      checked={certificadoestudiono}
                    />
                  }
                  label={'No'}
                />
              </div>
            </Grid>
          </Grid>

          {/*FILE CERTIFICADO ESTUDIOS  */}
          {certificadoestudiosi && (
            <UploadButtonField
              accept={'application/pdf'}
              name={e_fileCertificadoEstudios.name}
              label={e_fileCertificadoEstudios.label}
              required={
                !(
                  formikProps.values.e_fileCertificadoEstudios ||
                  (formikProps.values.e_certificado_estudios_name_saved &&
                    !formikProps.values.e_certificado_estudios_name_saved.includes('dummy'))
                )
              }
              text={'Certificado de estudios'}
              onChange={uploadCertificadoEstudio}
              style={{ marginTop: 10, width: '100%' }}
            />
          )}

          {certificadoestudiosi &&
          (formikProps.values.e_fileCertificadoEstudios ||
            formikProps.values.e_certificado_estudios_name_saved) ? (
            <Card variant="elevation" sx={{ marginTop: 1.5, padding: 1 }}>
              <LinearProgressWithLabel
                percentage={
                  formikProps.values.e_certificado_estudios_name_saved
                    ? 100
                    : percentage_upload_certificado_estudio
                }
                label={
                  formikProps.values.e_fileCertificadoEstudios?.name || 'Certificado de estudios'
                }
                hasIcon={true}
              />
              {!String(formikProps.values.e_certificado_estudios_name_saved).includes('dummy') && (
                <PreviewPdfButton
                  fileName={formikProps.values.e_certificado_estudios_name_saved}
                  typeUrl="laboral-empleado"
                  onOpenPdf={props.onOpenPdf}
                />
              )}
            </Card>
          ) : (
            ''
          )}
          {/*END FILE CERTIFICADO ESTUDIOS  */}
        </Grid>
        <Grid size={{ xs: 1 }}></Grid>

        <Grid size={{ xs: 3 }}>
          <Typography sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>
            ¿Certificado laboral?
          </Typography>
          <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => certificadoLaboralSi()}
                      name={'cert_laboral_si'}
                      checked={certificadolaboralsi}
                    />
                  }
                  label={'Si'}
                />
              </div>
            </Grid>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => certificadoLaboralNo()}
                      name={'cert_laboral_no'}
                      checked={certificadolaboralno}
                    />
                  }
                  label={'No'}
                />
              </div>
            </Grid>
          </Grid>

          {/*FILE CERTIFICADO LABORAL  */}
          {certificadolaboralsi && (
            <UploadButtonField
              accept={'application/pdf'}
              name={e_fileCertificadoLaboral.name}
              label={e_fileCertificadoLaboral.label}
              required={
                !(
                  formikProps.values.e_fileCertificadoLaboral ||
                  (formikProps.values.e_certificado_laboral_name_saved &&
                    !formikProps.values.e_certificado_laboral_name_saved.includes('dummy'))
                )
              }
              text={'Certificado laboral'}
              onChange={uploadCertificadoLaboral}
              style={{ marginTop: 10, width: '100%' }}
            />
          )}

          {certificadolaboralsi &&
          (formikProps.values.e_fileCertificadoLaboral ||
            formikProps.values.e_certificado_laboral_name_saved) ? (
            <Card variant="elevation" sx={{ marginTop: 1.5, padding: 1 }}>
              <LinearProgressWithLabel
                percentage={
                  formikProps.values.e_certificado_laboral_name_saved
                    ? 100
                    : percentage_upload_certificado_laboral
                }
                label={formikProps.values.e_fileCertificadoLaboral?.name || 'Certificado laboral'}
                hasIcon={true}
              />
              {!String(formikProps.values.e_certificado_laboral_name_saved).includes('dummy') && (
                <PreviewPdfButton
                  fileName={formikProps.values.e_certificado_laboral_name_saved}
                  typeUrl="laboral-empleado"
                  onOpenPdf={props.onOpenPdf}
                />
              )}
            </Card>
          ) : (
            ''
          )}
          {/* END FILE CERTIFICADO LABORAL  */}
        </Grid>
        <Grid size={{ xs: 1 }}></Grid>
      </Grid>
      {/* END GRID  */}

      <Grid container spacing={2} sx={{ borderTop: '2px solid #eceaea', marginTop: 4 }}>
        <Grid size={{ xs: 3 }}>
          <Typography sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>
            ¿Verificación ADRES?
          </Typography>
          <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => verificacionAddresSi()}
                      name={'ver_address_si'}
                      checked={verificacionaddresi}
                    />
                  }
                  label={'Si'}
                />
              </div>
            </Grid>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => verificacionAddresNo()}
                      name={'ver_address_no'}
                      checked={verificacionaddreno}
                    />
                  }
                  label={'No'}
                />
              </div>
            </Grid>
          </Grid>

          {/*FILE VERIFICACION ADRES  */}
          {verificacionaddresi && (
            <UploadButtonField
              accept={'application/pdf'}
              name={e_fileVerificacionAdres.name}
              label={e_fileVerificacionAdres.label}
              required={
                !(
                  formikProps.values.e_fileVerificacionAdres ||
                  (formikProps.values.e_verificacion_adres_name_saved &&
                    !formikProps.values.e_verificacion_adres_name_saved.includes('dummy'))
                )
              }
              text={'Verificación ADRES'}
              onChange={uploadVerificacionAdres}
              style={{ marginTop: 10, width: '100%' }}
            />
          )}

          {verificacionaddresi &&
          (formikProps.values.e_fileVerificacionAdres ||
            formikProps.values.e_verificacion_adres_name_saved) ? (
            <Card variant="elevation" sx={{ marginTop: 1.5, padding: 1 }}>
              <LinearProgressWithLabel
                percentage={
                  formikProps.values.e_verificacion_adres_name_saved
                    ? 100
                    : percentage_upload_verificacion_adres
                }
                label={formikProps.values.e_fileVerificacionAdres?.name || 'Verificación ADRES'}
                hasIcon={true}
              />
              {!String(formikProps.values.e_verificacion_adres_name_saved).includes('dummy') && (
                <PreviewPdfButton
                  fileName={formikProps.values.e_verificacion_adres_name_saved}
                  typeUrl="laboral-empleado"
                  onOpenPdf={props.onOpenPdf}
                />
              )}
            </Card>
          ) : (
            ''
          )}
          {/* END FILE VERIFICACION ADRES  */}
        </Grid>

        <Grid size={{ xs: 1 }}></Grid>

        <Grid size={{ xs: 3 }}>
          <Typography sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>
            ¿Antecedentes?
          </Typography>
          <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => antecedentesSi()}
                      name={'antecedentes_si'}
                      checked={antecedentessi}
                    />
                  }
                  label={'Si'}
                />
              </div>
            </Grid>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => antecedentesNo()}
                      name={'antecedentes_no'}
                      checked={antecedentesno}
                    />
                  }
                  label={'No'}
                />
              </div>
            </Grid>
          </Grid>

          {/*FILE ANTECEDENTES  */}
          {antecedentessi && (
            <UploadButtonField
              accept={'application/pdf'}
              name={e_fileAntecedentes.name}
              label={e_fileAntecedentes.label}
              required={
                !(
                  formikProps.values.e_fileAntecedentes ||
                  (formikProps.values.e_antecedentes_name_saved &&
                    !formikProps.values.e_antecedentes_name_saved.includes('dummy'))
                )
              }
              text={'Antecedentes'}
              onChange={uploadAntecedentes}
              style={{ marginTop: 10, width: '100%' }}
            />
          )}

          {antecedentessi &&
          (formikProps.values.e_fileAntecedentes ||
            formikProps.values.e_antecedentes_name_saved) ? (
            <Card variant="elevation" sx={{ marginTop: 1.5, padding: 1 }}>
              <LinearProgressWithLabel
                percentage={
                  formikProps.values.e_antecedentes_name_saved
                    ? 100
                    : percentage_upload_antecedentes
                }
                label={formikProps.values.e_fileAntecedentes?.name || 'Antecedentes'}
                hasIcon={true}
              />
              {!String(formikProps.values.e_antecedentes_name_saved).includes('dummy') && (
                <PreviewPdfButton
                  fileName={formikProps.values.e_antecedentes_name_saved}
                  typeUrl="laboral-empleado"
                  onOpenPdf={props.onOpenPdf}
                />
              )}
            </Card>
          ) : (
            ''
          )}
          {/* END FILE ANTECEDENTES  */}
        </Grid>
        <Grid size={{ xs: 1 }}></Grid>

        <Grid size={{ xs: 3 }}>
          <Typography sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>
            ¿Entrevista?
          </Typography>
          <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => entrevistaSi()}
                      name={'entrevista_si'}
                      checked={entrevistasi}
                    />
                  }
                  label={'Si'}
                />
              </div>
            </Grid>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => entrevistaNo()}
                      name={'entrevista_no'}
                      checked={entrevistano}
                    />
                  }
                  label={'No'}
                />
              </div>
            </Grid>
          </Grid>

          {/*FILE ENTREVISTA  */}
          {entrevistasi && (
            <UploadButtonField
              accept={'application/pdf'}
              name={e_fileEntrevista.name}
              label={e_fileEntrevista.label}
              required={
                !(
                  formikProps.values.e_fileEntrevista ||
                  (formikProps.values.e_entrevista_name_saved &&
                    !formikProps.values.e_entrevista_name_saved.includes('dummy'))
                )
              }
              text={'Entrevista'}
              onChange={uploaEntrevista}
              style={{ marginTop: 10, width: '100%' }}
            />
          )}

          {entrevistasi &&
          (formikProps.values.e_fileEntrevista || formikProps.values.e_entrevista_name_saved) ? (
            <Card variant="elevation" sx={{ marginTop: 1.5, padding: 1 }}>
              <LinearProgressWithLabel
                percentage={
                  formikProps.values.e_entrevista_name_saved ? 100 : percentage_upload_entrevista
                }
                label={formikProps.values.e_fileEntrevista?.name || 'Entrevista'}
                hasIcon={true}
              />
              {!String(formikProps.values.e_entrevista_name_saved).includes('dummy') && (
                <PreviewPdfButton
                  fileName={formikProps.values.e_entrevista_name_saved}
                  typeUrl="laboral-empleado"
                  onOpenPdf={props.onOpenPdf}
                />
              )}
            </Card>
          ) : (
            ''
          )}
          {/* END FILE ENTREVISTA  */}
        </Grid>
        <Grid size={{ xs: 1 }}></Grid>
      </Grid>
      {/* END GRID  */}

      <Grid container spacing={2} sx={{ borderTop: '2px solid #eceaea', marginTop: 4 }}>
        <Grid size={{ xs: 3 }}>
          <Typography sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>
            ¿Encuesta sociodemografica?
          </Typography>
          <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => socioDemograficaSi()}
                      name={'sociodemografica_si'}
                      checked={sociodemograficasi}
                    />
                  }
                  label={'Si'}
                />
              </div>
            </Grid>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => socioDemograficaNo()}
                      name={'sociodemografica_no'}
                      checked={sociodemograficano}
                    />
                  }
                  label={'No'}
                />
              </div>
            </Grid>
          </Grid>

          {/*FILE ENTREVISTA SOCIODEMOGRAFICA */}
          {sociodemograficasi && (
            <UploadButtonField
              accept={'application/pdf'}
              name={e_fileSociodemografica.name}
              label={e_fileSociodemografica.label}
              required={
                !(
                  formikProps.values.e_fileSociodemografica ||
                  (formikProps.values.e_sociodemografica_name_saved &&
                    !formikProps.values.e_sociodemografica_name_saved.includes('dummy'))
                )
              }
              text={'Sociodemografica'}
              onChange={uploaEntrevistaSociodemografica}
              style={{ marginTop: 10, width: '100%' }}
            />
          )}

          {sociodemograficasi &&
          (formikProps.values.e_fileSociodemografica ||
            formikProps.values.e_sociodemografica_name_saved) ? (
            <Card variant="elevation" sx={{ marginTop: 1.5, padding: 1 }}>
              <LinearProgressWithLabel
                percentage={
                  formikProps.values.e_sociodemografica_name_saved
                    ? 100
                    : percentage_upload_entrevista_sociodemografica
                }
                label={formikProps.values.e_fileSociodemografica?.name || 'Sociodemografica'}
                hasIcon={true}
              />
              {!String(formikProps.values.e_sociodemografica_name_saved).includes('dummy') && (
                <PreviewPdfButton
                  fileName={formikProps.values.e_sociodemografica_name_saved}
                  typeUrl="laboral-empleado"
                  onOpenPdf={props.onOpenPdf}
                />
              )}
            </Card>
          ) : (
            ''
          )}
          {/* END FILE ENTREVISTA SOCIODEMOGRAFICA */}
        </Grid>
        <Grid size={{ xs: 1 }}></Grid>

        <Grid size={{ xs: 3 }}>
          <Typography sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>
            ¿Encuesta DME?
          </Typography>
          <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => encuestaDmeSi()}
                      name={'encuesta_dme_si'}
                      checked={encuestadmesi}
                    />
                  }
                  label={'Si'}
                />
              </div>
            </Grid>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => encuestaDmeNo()}
                      name={'encuesta_dme_no'}
                      checked={encuestadmeno}
                    />
                  }
                  label={'No'}
                />
              </div>
            </Grid>
          </Grid>

          {/*FILE ENCUESTA DME */}
          {encuestadmesi && (
            <UploadButtonField
              accept={'application/pdf'}
              name={e_fileEncuestaDme.name}
              label={e_fileEncuestaDme.label}
              required={
                !(
                  formikProps.values.e_fileEncuestaDme ||
                  (formikProps.values.e_encuesta_dme_name_saved &&
                    !formikProps.values.e_encuesta_dme_name_saved.includes('dummy'))
                )
              }
              text={'Encuesta DME'}
              onChange={uploadEncuestaDme}
              style={{ marginTop: 10, width: '100%' }}
            />
          )}

          {encuestadmesi &&
          (formikProps.values.e_fileEncuestaDme || formikProps.values.e_encuesta_dme_name_saved) ? (
            <Card variant="elevation" sx={{ marginTop: 1.5, padding: 1 }}>
              <LinearProgressWithLabel
                percentage={
                  formikProps.values.e_encuesta_dme_name_saved
                    ? 100
                    : percentage_upload_encuesta_dme
                }
                label={formikProps.values.e_fileEncuestaDme?.name || 'Encuesta DME'}
                hasIcon={true}
              />
              {!String(formikProps.values.e_encuesta_dme_name_saved).includes('dummy') && (
                <PreviewPdfButton
                  fileName={formikProps.values.e_encuesta_dme_name_saved}
                  typeUrl="laboral-empleado"
                  onOpenPdf={props.onOpenPdf}
                />
              )}
            </Card>
          ) : (
            ''
          )}
          {/* END FILE ENCUESTA DME */}
        </Grid>
        <Grid size={{ xs: 1 }}></Grid>

        <Grid size={{ xs: 3 }}>
          <Typography sx={{ fontWeight: 'bold', marginTop: 4, paddingLeft: 1 }}>
            ¿Compromiso SST?
          </Typography>
          <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => compromisoSstSi()}
                      name={'compromiso_sst_si'}
                      checked={compromisosstsi}
                    />
                  }
                  label={'Si'}
                />
              </div>
            </Grid>
            <Grid size={{ xs: 4 }} sx={{ padding: 2 }}>
              <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => compromisoSstNo()}
                      name={'compromiso_sst_no'}
                      checked={compromisosstno}
                    />
                  }
                  label={'No'}
                />
              </div>
            </Grid>
          </Grid>
          {/*FILE COMPROMISO SST */}
          {compromisosstsi && (
            <UploadButtonField
              accept={'application/pdf'}
              name={e_fileCompromisoSst.name}
              label={e_fileCompromisoSst.label}
              required={
                !(
                  formikProps.values.e_fileCompromisoSst ||
                  (formikProps.values.e_compromiso_sst_name_saved &&
                    !formikProps.values.e_compromiso_sst_name_saved.includes('dummy'))
                )
              }
              text={'Compromiso SST'}
              onChange={uploadCompromisoSst}
              style={{ marginTop: 10, width: '100%' }}
            />
          )}

          {compromisosstsi &&
          (formikProps.values.e_fileCompromisoSst ||
            formikProps.values.e_compromiso_sst_name_saved) ? (
            <Card variant="elevation" sx={{ marginTop: 1.5, padding: 1 }}>
              <LinearProgressWithLabel
                percentage={
                  formikProps.values.e_compromiso_sst_name_saved
                    ? 100
                    : percentage_upload_compromiso_sst
                }
                label={formikProps.values.e_fileCompromisoSst?.name || 'Compromiso SST'}
                hasIcon={true}
              />
              {!String(formikProps.values.e_compromiso_sst_name_saved).includes('dummy') && (
                <PreviewPdfButton
                  fileName={formikProps.values.e_compromiso_sst_name_saved}
                  typeUrl="laboral-empleado"
                  onOpenPdf={props.onOpenPdf}
                />
              )}
            </Card>
          ) : (
            ''
          )}
          {/* END FILE COMPROMISO SST */}
        </Grid>
        <Grid size={{ xs: 1 }}></Grid>
      </Grid>
      {/* END GRID  */}
    </div>
  );
};
